var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-skeleton-wrapper', {
    attrs: {
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "loading",
      fn: function fn() {
        return [_c('div', {
          staticClass: "p-3"
        }, [_c('div', {
          staticClass: "w-50 mx-auto mb-2"
        }, [_c('b-skeleton-img', {
          attrs: {
            "aspect": "1:1"
          }
        })], 1), _c('div', [_c('b-skeleton', {
          staticClass: "mx-auto mb-1",
          attrs: {
            "width": "85%"
          }
        }), _c('b-skeleton', {
          staticClass: "mx-auto mb-1",
          attrs: {
            "width": "55%"
          }
        }), _c('b-skeleton', {
          staticClass: "mx-auto mb-1",
          attrs: {
            "width": "70%"
          }
        })], 1)])];
      },
      proxy: true
    }])
  }, [_vm.product ? _c('div', {
    staticClass: "product-viewer p-3 flex",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-carousel', {
    attrs: {
      "controls": _vm.images.length > 1,
      "interval": 0,
      "no-wrap": ""
    },
    model: {
      value: _vm.imagesIndex,
      callback: function callback($$v) {
        _vm.imagesIndex = $$v;
      },
      expression: "imagesIndex"
    }
  }, _vm._l(_vm.images, function (image) {
    return _c('b-carousel-slide', {
      key: image.id,
      scopedSlots: _vm._u([{
        key: "img",
        fn: function fn() {
          return [_c('b-card-img-lazy', {
            staticClass: "mb-2",
            attrs: {
              "fluid": "",
              "src": image.pic_url,
              "alt": "產品圖片"
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1), _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_vm._v(_vm._s(_vm.product.title))]), _c('div', {
    staticClass: "small"
  }, [_vm._v("單價：$" + _vm._s(_vm.product.price))])])], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }